import FullPageLoader from "@/components/Common/FullPageLoader";
import {useAgencyId, useIsInfuencer, useSelectedCompanyId} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {createFileRoute, Navigate} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile")({
  component: ProfilePage,
});

function ProfilePage() {
  const agencyId = useAgencyId();
  const selectedCompanyId = useSelectedCompanyId();
  const isInfluencer = useIsInfuencer();
  const user = useUserStore(state => state.user);

  if (!user.id) {
    return <FullPageLoader />;
  }

  if (isInfluencer) {
    return <Navigate to="/influencer/$influencerId" params={{influencerId: user.influencer_uuid!}} replace />;
  }

  if (!!selectedCompanyId) {
    return <Navigate to="/company/$companyId" params={{companyId: selectedCompanyId}} replace />;
  }

  if (!!agencyId) {
    return <Navigate to="/agency/$agencyId" params={{agencyId}} replace />;
  }

  return <Navigate to="/" replace />;
}
